import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {UtilService} from "../../modules/shared/services";
import {ToastrService} from "ngx-toastr";
import {NotesService} from "../../services";
import { Permission} from "../../modules/shared/models";
import { INoteItem, INoteCollection, NoteTypes} from "../../models";
import {DeleteConfirmationModalComponent} from "../../modules/shared/components";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {Action} from "rxjs/internal/scheduler/Action";
import { DataService } from 'src/app/services/data/data.service';


@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent {
  noteCollections: INoteCollection[] = [];
  selectedCollection: INoteCollection = {} as INoteCollection;
  notesList: INoteItem[] = [];
  noteBody: string = "";
  NoteTypes = NoteTypes;

  loading = false;
  isEditing: boolean = false;
  editIdx: string | null = null;

  @ViewChild('scrollMe') private myScrollContainer: ElementRef | undefined;


  constructor(
    private toastrService: ToastrService,
    private notesService: NotesService,
    private dialog: MatDialog,
    public util: UtilService,
    private dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: { notesType: NoteTypes, id: string }
  ) {
    // console.log("NOTES data", this.data)
    this.getNoteCollections(this.data.notesType, this.data.id);

    // console.log("Employee Permissions", this.dataService.currentEmployeePermissions)
    // console.log("DT Permissions", this.dataService.dealTeamPermissions)
  }

  get noteType(): string { return this.data.notesType }


  /**
   * Action to scroll the notes to bottom
   */
  scrollToBottom(): void {
    setTimeout(() => {
      if (!!this.myScrollContainer) {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
      }
    }, 200);
  }

  /**
   * Get the note collection from the top level object currently being inspected
   * @param type the type of object DEAL, BUSINESSUNIT, MANDATE
   * @param id the id of the object
   */
  getNoteCollections(type: NoteTypes, id: string) {
    if (this.canGetNotes == false) {
      this.toastrService.error("User does not have access to notes");
      return;
    }

    if (!!type && !!id) {
      this.notesService.getNoteCollections(type, id).subscribe({
        next: (collections: INoteCollection[]) => {
          console.log("notes collection", collections)
          this.noteCollections = collections;
          if (this.noteCollections.length > 0) {
            this.selectedCollection = this.noteCollections[0];
            this.getNotes(this.selectedCollection);
          }
        }, error: (error: any) => {
          this.toastrService.error("Something went wrong!");
        }
      });
    }
  }

  /**
   * The change collection action
   * @param event a note collection event
   */
  changeNoteCollection(event: any) {
    // console.log(event);
    this.selectedCollection = event.value as INoteCollection;
    this.getNotes(this.selectedCollection);
  }

  /**
   * Get the notes for the selected collection
   */
  getNotes(collection: INoteCollection) {
    this.showSpinner();
    this.notesService.getNoteCollection(this.selectedCollection.notesCollectionId).subscribe({
      next: (notes: INoteItem[]) => {
        this.notesList = notes;
        this.scrollToBottom();
      }, error: (error: any) => {
        this.toastrService.error("Something went wrong!");
      }
    });
  }

  get canGetNotes() : boolean {
     switch (this.data.notesType) {
      case NoteTypes.DEAL: 
        return this.util.hasPermission(Permission.CAN_ACCESS_DEAL_NOTES);
      case NoteTypes.MANDATE:
        return this.util.hasPermission(Permission.CAN_ACCESS_MANDATE_NOTES);
      case NoteTypes.BUSINESSUNIT:
        var yes = this.util.hasPermission(Permission.CAN_ACCESS_BUSINESS_UNITS_NOTES);
        return this.util.hasPermission(Permission.CAN_ACCESS_BUSINESS_UNITS_NOTES);
    } 
    return false;
  }

  get canAddNote() : boolean { 
    switch (this.data.notesType) {
      case NoteTypes.DEAL: 
        return this.util.hasPermission(Permission.CAN_ADD_DEAL_NOTES);
      case NoteTypes.MANDATE:
        return this.util.hasPermission(Permission.CAN_ADD_MANDATE_NOTES);
      case NoteTypes.BUSINESSUNIT:
        return this.util.hasPermission(Permission.CAN_ADD_BUSINESS_UNITS_NOTES);
    } 
    return false;
  }

  get canEditNote() : boolean { 
    switch (this.data.notesType) {
      case NoteTypes.DEAL: 
        return this.util.hasPermission(Permission.CAN_EDIT_DEAL_NOTES);
      case NoteTypes.MANDATE:
        return this.util.hasPermission(Permission.CAN_EDIT_MANDATE_NOTES);
      case NoteTypes.BUSINESSUNIT:
        return this.util.hasPermission(Permission.CAN_EDIT_BUSINESS_UNITS_NOTES);
    } 
    return false;
  }

  get canDeleteNote() : boolean {
    switch (this.data.notesType) {
      case NoteTypes.DEAL: 
        return this.util.hasPermission(Permission.CAN_DELETE_DEAL_NOTES);
      case NoteTypes.MANDATE:
        return this.util.hasPermission(Permission.CAN_DELETE_MANDATE_NOTES);
      case NoteTypes.BUSINESSUNIT:
        return this.util.hasPermission(Permission.CAN_DELETE_BUSINESS_UNITS_NOTES);
    } 
    return false;
  }

  sendNewMessage() {
    if (!this.noteBody) {
      this.toastrService.error("Message cannot be empty");
      return;
    }

    if (this.isEditing) {
      if (!this.editIdx) {
        this.toastrService.error("Missing Edit Id");
        return;
      }

      this.notesService.updateNote(this.editIdx, this.noteBody).subscribe({
        next: (res: any) => {
          this.clearEditModeAndForm();
          this.getNotes(this.selectedCollection);
          this.toastrService.success("Note Updated!", $localize`:@@companyName:Rondeivu`);
        }, error: (error: any) => {
          this.toastrService.error("Something went wrong!");
        }
      });

    } else {

      this.notesService.addNote(this.selectedCollection.notesCollectionId, this.noteBody).subscribe({
        next: (res: any) => {
          this.clearEditModeAndForm();
          this.getNotes(this.selectedCollection);
          this.toastrService.success("Note Added!", $localize`:@@companyName:Rondeivu`);
        }, error: (error: any) => {
          this.toastrService.error("Something went wrong!");
        }
      });
    }

    
  }

  editNote(note: INoteItem) {
    console.log("edit", note);
    this.editIdx = note.id;
    // this.fg.patchValue({ msg: note.note });
    this.noteBody = note.note;
    this.isEditing = true;
  }

  clearEditModeAndForm() {
    this.isEditing = false;
    this.editIdx = '';
    this.noteBody = '';
    // var control = this.fg.get("msg");
    // console.log("control", control)
    // control?.setErrors(null);
    // control?.reset();
    // control?.markAsPristine();
    // control?.markAsUntouched();
    // control?.updateValueAndValidity();

    // this.fg.reset();
    // // this.fg.reset
    // this.fg.setErrors(null);
    // this.fg.markAsPristine();
    // this.fg.markAsUntouched();
    // this.fg.clearValidators();
    // this.fg.updateValueAndValidity();

  }

  /**
   * Delete action
   * @param note
   */
  deleteNote(note: INoteItem) {
    this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      data: note
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.notesService.deleteNote(note.id).subscribe({
        next: (res: any) => {
          this.getNotes(this.selectedCollection);
          this.toastrService.success("Note Removed!", $localize`:@@companyName:Rondeivu`);
        }, error: (error: any) => {
          this.toastrService.error("Something went wrong!");
        }
      });
      }
    });
  }

  private showSpinner() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  protected readonly Action = Action;
}
